/**
 * Product reviews API.
 *
 * Backend routes (added in this release):
 *   GET    /api/v1/skus/:skuId/reviews          → list + aggregate stats
 *   POST   /api/v1/skus/:skuId/reviews          → upsert caller's review
 *   GET    /api/v1/customers/me/reviews         → caller's own reviews
 *   DELETE /api/v1/skus/:skuId/reviews/:id      → caller deletes their review
 */

import { apiClient } from './apiClient';

export interface BackendReview {
  id: number;
  sku_id: number;
  customer_id: number;
  customer_name?: string;
  rating: number;
  title: string | null;
  comment: string | null;
  is_verified_purchase: boolean;
  helpful_count: number;
  created_at: string;
  updated_at: string;
}

export interface ReviewListResponse {
  data: BackendReview[];
  pagination: { total: number; page: number; limit: number; pages: number };
  stats: {
    average_rating: number;
    total: number;
    breakdown: Record<'1' | '2' | '3' | '4' | '5', number>;
  };
}

export async function listSkuReviews(
  skuId: number,
  filters: { page?: number; limit?: number } = {}
): Promise<ReviewListResponse> {
  return apiClient.get<ReviewListResponse>(`/skus/${skuId}/reviews`, filters);
}

export async function submitReview(
  skuId: number,
  input: { rating: number; title?: string; comment?: string }
): Promise<BackendReview> {
  return apiClient.post<BackendReview>(`/skus/${skuId}/reviews`, input);
}

export async function deleteReview(skuId: number, reviewId: number): Promise<void> {
  await apiClient.delete<void>(`/skus/${skuId}/reviews/${reviewId}`);
}
